export enum Pages {
  Start = '/start',
  Login = '/login',
  Home = '/',
  Status = '/status',
  UserLookup = '/userlookup',
  SessionInfo = '/sessioninfo',
  ErrorPage = '/error',
  ConfigSearch = '/configlookup',
  ConfigInfo = '/configInfo',
  UserClientLookup = '/userclientlookup',
  Filtering = '/filtering',
  HorizonOptOutTracker = '/horizonoptouttracker',
  IFrameTesting = '/iframetesting',
  RecentSessions = '/recentsessions',
  UserManagement = '/usermanagement',
}
